var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{model:{value:(_vm.dictValue),callback:function ($$v) {_vm.dictValue=$$v},expression:"dictValue"}},_vm._l((_vm.list),function(item){return _c('el-checkbox',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }